"use strict";
/**
 * Rate Sheet Types
 *
 * Type definitions for ARW-sourced rate sheet data. Uses `RateSheet` prefix
 * to avoid conflicts with the existing ProductType and CreditingStrategy
 * types in models.ts.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=rate-sheet.types.js.map